var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizeColumns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.67429L8.16118 14.7429C7.82353 14.5286 7.41176 14.4 7 14.4C5.76471 14.4 4.77647 15.4286 4.77647 16.7143V18H1.64706C0.741176 18 0 17.2371 0 16.2857V13.0286H1.23529C2.47059 13.0286 3.45882 12 3.45882 10.7143C3.45882 9.42857 2.47059 8.4 1.23529 8.4H0V5.14286C0 4.2 0.741176 3.42857 1.64706 3.42857H4.94118V2.14286C4.94118 0.96 5.86353 0 7 0C8.13647 0 9.05882 0.96 9.05882 2.14286V3.42857H12.3529C13.2588 3.42857 14 4.19143 14 5.14286V8.67429Z",
    fill: "#99D5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2037 10.1378C16.293 10.0486 16.4065 10 16.52 10C16.6336 10 16.739 10.0486 16.8282 10.1378L17.8662 11.1753C18.0446 11.3455 18.0446 11.6292 17.8662 11.7994L17.0552 12.6099L15.3928 10.9483L16.2037 10.1378Z",
    fill: "#0096D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.3303L14.9225 11.4184L16.5849 13.08L11.6706 18H10V16.3303Z",
    fill: "#0096D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeColumns);
export default __webpack_public_path__ + "static/media/customize-columns.ba6b71394c86a0f7bd45d3996fe737eb.svg";
export { ForwardRef as ReactComponent };